module.exports = __webpack_public_path__ + "img/Spotify-App2.08b67f72.svg";